import { dew as _ListGuestsResponseDew } from "./ListGuestsResponse";
import { dew as _CreateGuestResponseDew } from "./CreateGuestResponse";
import { dew as _GuestResponseDew } from "./GuestResponse";
import { dew as _GuestDew } from "./Guest";
import { dew as _GuestConfigDew } from "./GuestConfig";
import { dew as _GuestConfigUpdateDew } from "./GuestConfigUpdate";
import { dew as _GuestWorkbookDew } from "./GuestWorkbook";
import { dew as _GuestSpaceDew } from "./GuestSpace";
import { dew as _InviteDew } from "./Invite";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  var __createBinding = exports && exports.__createBinding || (Object.create ? function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = {
        enumerable: true,
        get: function () {
          return m[k];
        }
      };
    }
    Object.defineProperty(o, k2, desc);
  } : function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
  });
  var __exportStar = exports && exports.__exportStar || function (m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  __exportStar(_ListGuestsResponseDew(), exports);
  __exportStar(_CreateGuestResponseDew(), exports);
  __exportStar(_GuestResponseDew(), exports);
  __exportStar(_GuestDew(), exports);
  __exportStar(_GuestConfigDew(), exports);
  __exportStar(_GuestConfigUpdateDew(), exports);
  __exportStar(_GuestWorkbookDew(), exports);
  __exportStar(_GuestSpaceDew(), exports);
  __exportStar(_InviteDew(), exports);
  return exports;
}